import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=52d3c4aa&scoped=true"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=52d3c4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3c4aa",
  null
  
)

export default component.exports